import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GrantService } from '../_services/grant.service';
import { Grant } from '../_models/grant';
import { HouseholdMember } from '../_models/household-member';
import { AuthenticationService } from '../_services/authentication.service';
import { User } from '../_models/user';
import { Note } from '../_models/note';
import { NoteList } from '../_models/notelist';
import { Status } from '../_models/status';
import { StatusService } from '../_services/status.service';

@Component({
  moduleId: module.id,
  templateUrl: 'grant-form.component.html',
  styleUrls: ['grant-form.component.css']
})

export class GrantFormComponent implements OnInit {
  public grant: Grant;
  public householdMembers: HouseholdMember[];
  public notes: Note[];
  public adminnotes: Note[];
  public newFiles: FileList;
  public statuses: Array<Status>;
  public showSubmitSuccess: boolean;
  public showAccessDenied: boolean;
  public savingData: boolean;

  constructor(
    private grantService: GrantService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private statusService: StatusService
  ) { }

  ngOnInit() {
    this.grant = new Grant();
    this.householdMembers = [];
    this.notes = [];
    this.adminnotes = [];

    this.showSubmitSuccess = false;
    this.savingData = false;
    this.showAccessDenied = false;

    this.removeHouseholdMember = this.generateRemoveHouseholdMember(this.householdMembers);

    Promise.all<Status[]>([this.statusService.getAll()])
      .then(([statuses, users, roles]) => {
        this.statuses = statuses;
        window.scrollTo(0,0);

        this.route.params.subscribe(params => {
          var id: string = params['id'];

          if (!!id) {

            this.grantService.getById(id)
                .then(x => {
                    //Did we not get a value back from the promise? If so, access is denied.
                    if (x === undefined){
                        this.grant.status_id = '1';
                        this.showAccessDenied = true;
                    } else {
                        this.grant = x;
                        this.grantService.getHouseholdMembersByGrantId(id)
                            .then(x => {
                                this.householdMembers = x
                                this.removeHouseholdMember = this.generateRemoveHouseholdMember(this.householdMembers);
                        });

                        this.grantService.getNotesByGrantId(id)
                            .then(x => {
                                this.notes = x['notes']; 
                                this.adminnotes = x['adminnotes']; 
                        });
                    }
                });

          } else {
            this.grant.status_id = '1';
            this.grant.status_name = statuses.filter(x => x.id === '1')[0].name;

            this.grant.user_email = this.authenticationService.currentUser.username;
            this.grant.user_name = this.authenticationService.currentUser.name;
            this.grant.agency_name = ( this.authenticationService.currentUser.organization ? this.authenticationService.currentUser.organization : '' );
          }
        });
      });
  }

  addNote(text: string, adminnote: string) {

    let note = new Note();

    note.application_id = this.grant.id;
    note.note = text;
    note.user_id = this.authenticationService.currentUser.id;
    note.adminnote = adminnote;

    
    this.grantService
      .submitNote(this.grant.id, note)
      .then((note) => {
            this.grantService.getNotesByGrantId(this.grant.id)
                .then(x => {
                    this.notes = x['notes']; 
                    this.adminnotes = x['adminnotes']; 
            });
    });
  }

  addHouseholdMember() {
    this.householdMembers.push(new HouseholdMember());
  }

  removeHouseholdMember: (householdMember: HouseholdMember) => void;

  //Creating an enclosure to avoid issues with the javascript this pointer
  private generateRemoveHouseholdMember(householdMembers: HouseholdMember[]) {
    return (householdMember: HouseholdMember) => {
      householdMembers.splice(householdMembers.indexOf(householdMember), 1);
    };
  }


  editStatus(status: Status) {
   this.grantService.editStatus(this.grant, status, this.authenticationService.currentUser.organization_id);
  }

  submitButtonText() {
    if (this.grant.id){
        return this.grant.status_id == "3" ? "Resubmit Application" : "Save Application";
    } else {
        return "Submit Application";
    }
  }

  submit(){
    window.scrollTo(0,0);
    this.savingData = true;
    this.showSubmitSuccess = false;

    this.grantService
      .submitGrantWithHouseholdMembers(this.grant, this.householdMembers, this.newFiles)
      .then(([grant, householdMembers, files]) => {
        this.grant = grant;
        this.householdMembers = householdMembers;
        this.showSubmitSuccess = true;
        this.savingData = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/grant-form/grant-form.component.ts